import { useState } from "react";

export default function Section9() {
  const faqs = [
    {
      question: "How long does it take to see results from SEO services?",
      answer:
        "Results vary depending on your industry, competition, and current website health. Most businesses start seeing measurable improvements in 3–6 months with consistent SEO efforts."
    },
    {
      question: "Can you improve my local search visibility in Texas cities?",
      answer:
        "Yes. We optimize your Google Business Profile, build local citations, and implement location-specific content to help your business appear in local searches across Texas"
    },
    {
      question: "Will my current website work for SEO, or do I need a redesign?",
      answer:
        "Most websites can be optimized, but sometimes a redesign is recommended to fix technical issues, improve speed, or enhance UX for better SEO performance."
    },
    {
      question: "Do you guarantee first-page rankings on Google?",
      answer:
        " While no reputable agency can guarantee rankings due to search engine algorithms, we focus on proven strategies that improve visibility, traffic, and qualified leads over time."
    }
   
  ];

  const [isOpen, setIsOpen] = useState(new Array(faqs.length).fill(false));

  const handleFaq = (index) => {
    setIsOpen((prevState) =>
      prevState.map((item, idx) => (idx === index ? !item : false))
    );
  };

  return (
    <div className="w-full Section9 mt-[8%] md:mt-[4%]">
      <div className="w-full section9-container">
        <div className="w-[90%] md:w-[61%] pb-[1%] mx-auto text-center">
          <h2 className="leading-[29px] md:leading-[41px] text-[24px] md:text-[34px] text-[#151515] font-bold my-[0.67em]">
            FAQs about SEO Services
          </h2>
        </div>

        <div className="w-full md:w-[784px] p-5 md:p-[2%] mx-auto faq-container font-open leading-[21px]">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className="faq-item text-[11px] md:text-sm rounded-[8px] p-[2%] border border-solid border-[#DEDEDE] mb-[4%]"
              style={{
                background:
                  "linear-gradient(0deg, #FEFFFF, #FEFFFF), linear-gradient(0deg, #DEDEDE, #DEDEDE)",
              }}
            >
              <div
                onClick={() => handleFaq(index)}
                className="question text-[#444444] cursor-pointer flex justify-between items-center"
              >
                {faq.question}
                <b className="text-[40px] text-[#DA2128] font-[300]">
                  {isOpen[index] ? "-" : "+"}
                </b>
              </div>
              <div className={`${isOpen[index] ? "block" : "hidden"} answer text-[#444444]`}>
                <br />
                <p className="mb-5">{faq.answer}</p>
              </div>
            </div>
          ))}
        </div>
      </div>

      <div className="line mb-[55px] md:mb-[4%] mt-[1%] mx-auto w-[70%] md:w-[61%] shadow-line h-2 rounded-[100%]"></div>
    </div>
  );
}
